export const API_URL = 'https://nv2mtil1t1.execute-api.eu-west-2.amazonaws.com';
// export const API_URL = 'http://localhost:5000';
